import { setContext } from "shared/providers/apollo/link/context.package";
import { getLocalStorageItem } from "shared/utils/local-storage";

import { propertyIdVar } from "./vars/property-id.var";

import { WEB_AUTH_TOKEN } from "shared/common/data/constants";

const authLink = setContext((_, { headers }) => {
  const token = getLocalStorageItem(WEB_AUTH_TOKEN);

  // Lowercase because headers are going to be lowercase anyways
  const propertyid = propertyIdVar();

  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(propertyid ? { propertyid } : {}),
    },
  };
});

export default authLink;
